import { FaStepBackward } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { useEffect, useRef } from "react";
import { PhaseType } from "../../interfaces/phase.Interface";
import axios from "axios";
import Button from "../Button";
import { useNotification } from "../../context/NotificationContext";





export default function Phases() {
  const dispatch = useAppDispatch()
  const current_phase = useAppSelector(state => state.Phases.current_phase);
  const goBackState = useAppSelector(state => state.GoBack.type);
  const active_events = useAppSelector(state => state.Actions.active_events);
  const aliasValue = useRef('');
  const { notify } = useNotification();
  const changePhase = (type: PhaseType) => {
    if(typeof active_events !== "undefined" && active_events?.length > 0){
      if(window.confirm("There are active actions in the current cruise phase. Are you sure you want to continue?")){

      }else{
        return;
      }
    }
    const newType = type;
    axios.post(process.env.REACT_APP_API_URI + `/phases/actions/changePhase`, { type: newType, alias: aliasValue.current })
    notify(newType.toString()+" started", { backgroundColor: "#00ff00", autoCloseMs: 3000 });
  }

  const goBack = () => {
    axios.post(process.env.REACT_APP_API_URI + `/goBack`, {})
  }
  return (
    <>
      <table>
        <tbody>
          <tr>
            <td className='font-bold w-1/2'>Current phase:</td>
            <td>{current_phase?.type} {current_phase?.index} {current_phase?.alias ? `(${current_phase.alias})` : ''}</td>
          </tr>
        </tbody >
      </table >
      <p className=' font-bold'> Change phase:</p>
      <label htmlFor='alias' className='mr-4'> Phase alias:</label><input id='alias' className='input_text w-1/4' placeholder="(optional)" onChange={(event) => aliasValue.current = event.target.value} type='text'></input>
      <div className='flex justify-between phases-buttons gap-1'>
          <Button extraClasses={current_phase?.type == PhaseType.CALL ? "active-phase" : ""} label="CALL" width="full" onClick={(event) => changePhase(PhaseType.CALL)} >          <img className="phase-image dark:filter-none" src="/images/call.svg"/></Button>
          <Button extraClasses={current_phase?.type == PhaseType.TRANSIT ? "active-phase" : ""} label="TRANSIT" width="full" onClick={(event) => changePhase(PhaseType.TRANSIT)}>   <img className="phase-image dark:filter-none" src="/images/transit.svg"/></Button>
          <Button extraClasses={current_phase?.type == PhaseType.STATION ? "active-phase" : ""} label="STATION" width="full" onClick={(event) => changePhase(PhaseType.STATION)} >  <img className="phase-image dark:filter-none" src="/images/station.svg"/></Button>
          <Button extraClasses={current_phase?.type == PhaseType.TRANSECT ? "active-phase" : ""} label="TRANSECT" width="full" onClick={(event) => changePhase(PhaseType.TRANSECT)} ><img className="phase-image dark:filter-none" src="/images/transect.svg"/></Button>
          {goBackState==="phase" ?
            <Button label={<FaStepBackward />} width="fit" onClick={(event) => goBack()}/>
            :
            <Button extraClasses="bg-gray-500 cursor-not-allowed hover:bg-gray-500" label={<FaStepBackward />} width="fit"/>
          }
      </div>
    </>
  )
}